import { useAuthStore } from '~~/stores/auth'

export const useAuthUser = () => useAuthStore().user
